import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import Loader from "components/atoms/loader";
import Header from "components/organisms/header";
import Footer from "components/organisms/footer";
import FormHero from "components/organisms/formHero";
import FormContent from "components/organisms/formContent";
import FormFieldset from "components/molecules/formFieldset";
import ContactForm from "components/organisms/contactForm";

import { fetchStockItem } from "actions/stock";
import { requestContact, resetContact } from "actions/contact";

import "./styles.scss";

class Contact extends React.Component {
  constructor(props) {
    super(props);

    this.props.fetch(props.match.params.id);

    this.props.reset();
  }

  handleSubmit(values) {
    const { vehicle } = this.props;

    values.used_stock_id = vehicle.id;
    values.vehicle_name =
      vehicle.brand + " " + vehicle.name + " (" + vehicle.license_plate + ")";

    this.props.contact(values);
  }

  render() {
    const { vehicle } = this.props;

    if (!vehicle || this.props.isFetching) {
      return (
        <div>
          <Header />
          <Loader />
        </div>
      );
    }

    return (
      <div>
        <Helmet>
          <title>
            Consultar por {vehicle.name} usado - Territorio Yacopini
          </title>
          <meta name="description" content="Consultas sobre vehículos usados" />
        </Helmet>
        <Header />
        <FormHero vehicle={vehicle} action="consultando por" />
        <FormContent>
          <h3>Consulta sobre este auto </h3>

          {this.props.error === true && (
            <FormFieldset>
              <p>Algo salió mal y no se pudo enviar tu consulta.</p>
              <p>
                Por favor volvé a intentarlo más tarde o llamanos garits a
                nuestro call center 0810 666 1033.
              </p>
            </FormFieldset>
          )}
          {this.props.error === false && !this.props.success && (
            <ContactForm onSubmit={this.handleSubmit.bind(this)} />
          )}
          {this.props.success === true && (
            <FormFieldset>
              <p>Recibimos tu consulta.</p>
              <p>
                Un asesor se estará comunicando con vos a la brevedad. Recordá
                que podés llamarnos gratis a nuestro call center 0810 666 1033.
              </p>
            </FormFieldset>
          )}
        </FormContent>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vehicle: state.stock.item,
    isFetching: state.contact.isFetching || state.stock.isFetching,
    success: state.contact.success,
    error: state.contact.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: (id) => {
      dispatch(fetchStockItem(id));
    },
    contact: (request) => {
      dispatch(requestContact(request));
    },
    reset: () => {
      dispatch(resetContact());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
